export const DifficultyEnum = {
  BEGINNER: "beginner",
  INTERMEDIATE: "intermediate",
  ADVANCED: "advanced",
  ALL: "all",
};

export const ScoringEnum = {
  COMPLETION: "completion",
  GRADED: "graded",
  RANKED: "ranked",
  CUSTOM: "custom",
}

export const EnforcementEnum = {
  QUIZ: "quiz",
  APPROVAL: "approval",
  AUTO: "auto",
  NONE: "none"
}

export const SubmissionScreenEnum = {
  PHOTO_UPLOAD: "photoUpload",
  QUIZ: "quiz",
  WRITTEN_REVIEW: "writtenReview",
  IN_PERSON_EVENT_ATTENDANCE: "inPersonEventAttendance",
  PAGE_COUNT: "pageCount",
  BOOK_COMPLETION: "bookCompletion",
}